import { ActivatedRouteSnapshot } from '@angular/router';

import { DataTrackLabelEnum } from 'app/shared/enums/data-track-label.enum';

export const PAGE_VIEW_EVENT = 'pageViewEvent';

const DATA_TRACK_LABEL_VALUES = new Set<string>(Object.values(DataTrackLabelEnum));

export function getPageViewEventFromRouteTree(root: ActivatedRouteSnapshot): DataTrackLabelEnum | undefined {
  let match: DataTrackLabelEnum | undefined;
  let route: ActivatedRouteSnapshot | null = root;

  while (route) {
    const eventType = route.data[PAGE_VIEW_EVENT];

    if (typeof eventType === 'string' && DATA_TRACK_LABEL_VALUES.has(eventType)) {
      match = eventType as DataTrackLabelEnum;
    }

    route = route.firstChild;
  }

  return match;
}

export function getRoutePatternFromRouteTree(root: ActivatedRouteSnapshot): string {
  const segments: string[] = [];
  let route: ActivatedRouteSnapshot | null = root;

  while (route) {
    const path = route.routeConfig?.path;

    if (path) {
      segments.push(path);
    }

    route = route.firstChild;
  }

  return '/' + segments.join('/');
}
